export class GetPublicMembersRequest {
    constructor(ipp: number, p: number, st: string, ist: string) {
        this.itemsPerPage = ipp;
        this.page = p;
        this.searchText = st;
        this.industrySearchText = ist;
    }
    itemsPerPage: number;
    page: number;
    searchText: string
    industrySearchText: string
}
